globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modals = appCustomerSpace.Modals || {};
appCustomerSpace.Modals.Settings = appCustomerSpace.Modals.Settings || {};

appCustomerSpace.Modals.Settings.SelectMediaAbstractFile = (function(superClass) {

  utils.extend(SelectMediaAbstractFile, superClass);

  function SelectMediaAbstractFile() {
    SelectMediaAbstractFile.__super__.constructor.apply(this, arguments);

    this.$buttonUploader = this.$html.find('.add-files');
    this.$selectedFileContainer = this.$html.find('.file-container');
    this.$mediaAbstractFilesContainer = this.$html.find('.media-files-container .files-items');

    this.$selectedMediaAbstractFile = this.$mediaAbstractFilesContainer.find('.selected');
  }

  $.extend(SelectMediaAbstractFile.prototype, {
    init: function() {
      var modal = this;
      modal._initUploader();
      modal._initEvents();
      modal._initSelectedMediaData();

      SearchFilter.initFilters($('.search-filter'));

      return SelectMediaAbstractFile.__super__.init.apply(this, arguments);
    },
    _initEvents: function(){
      var modal = this;

      modal.$html.on('click', 'button.submit', function(){
        modal._submit();
      });

      modal.$mediaAbstractFilesContainer.on('click', '.file-item:not(.selected)', function(){
        modal._selectMediaAbstractFile($(this));
      });
    },
    _initUploader: function(){
      var _this = this;

      this.uploader = new Uploader(this.$html, {
        data : {
          context: 'selection'
        },
        progress : {
          percent     : '.file-percent',
          progressbar : '.file-progressbar'
        },
        plupload : {
          drop_element  : this.$selectedFileContainer.closest('.thumbnail-container')[0],
          browse_button : this.$buttonUploader[0],
          multi_selection: false,
          url: _this.uploadPath,
        },
        callbacks : {
          filesAdded : function(up, files) {
            var files = Array.prototype.slice.call(files).reverse();

            for(var i = files.length - 1; i >= 0; i--) {
              _this._renderPreview(files[i]);
            }
          },
          uploadProgress : function(up, file) {
            var $preview = _this.$mediaAbstractFilesContainer.find('#' + file.id),
                percent = file.percent + '%';

            $preview.find(this.config.progress.percent).text(percent).end()
                    .find(this.config.progress.progressbar).css('width', percent);
          },
          fileUploaded : function(up, file, response) {
            if(response.error) {
              _this.$mediaAbstractFilesContainer.find('#' + file.id).addClass('error');
              setTimeout(function(){
                _this.$mediaAbstractFilesContainer.find('#' + file.id).fadeOut(200, function() { $(this).remove() })
              }, 5000);
            } else {
              var $newMediaAbstractFile = $(response.views.thumbnail),
                  thumbnailSample = _this.$mediaAbstractFilesContainer.find('.file-item .thumbnail')[0],
                  height = (thumbnailSample ? thumbnailSample.getBoundingClientRect().height : 60);

              $newMediaAbstractFile.find('.thumbnail').css('height', height)
              _this.$mediaAbstractFilesContainer.find('#' + file.id).replaceWith($newMediaAbstractFile);
              _this._selectMediaAbstractFile($newMediaAbstractFile);
            }
          }
        }
      });
    },
    _selectedMediaAbstractFileTemplate: function(){
      return $(this.$selectedFileContainer.find('template').html().trim());
    },
    _uploadingMediaAbstractFileTemplate: function(){
      return $(this.$mediaAbstractFilesContainer.find('template').html().trim());
    },
    _renderPreview: function(image) {
      if(image) {
        var modal = this,
            preview = modal._uploadingMediaAbstractFileTemplate().clone().attr('id', image.id),
            thumbnailSample = modal.$mediaAbstractFilesContainer.find('.file-item .thumbnail')[0],
            height = (thumbnailSample ? thumbnailSample.getBoundingClientRect().height : 60);

        preview.find('.thumbnail').css('height', height)
        modal.$mediaAbstractFilesContainer.prepend(preview.fadeIn(90));
      }
    }
  });

  return SelectMediaAbstractFile;

})(appCustomerSpace.Modal);
